import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
// import Checkbox from '@material-ui/core/Checkbox';
import {FusePageSimple} from '@fuse';
// import {TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy} from '@fuse';
import { Chip, Paper, Grid, Button, SwipeableDrawer, LinearProgress, Card, CardContent, CircularProgress, IconButton, CardHeader, Typography, Badge, Dialog, DialogContent, DialogContentText, DialogActions, Slide, Snackbar, Radio, FormControlLabel } from '@material-ui/core';
// import Pagination from "material-ui-flat-pagination";
// import Fab from '@material-ui/core/Fab';
import Formsy from 'formsy-react';
import {RadioGroupFormsy} from '@fuse';
// import ReactDOM from 'react-dom';
// import _ from '@lodash';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import PanelPertanyaan from './PanelPertanyaan';

import HomeIcon from '@material-ui/icons/Home';
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIcon from '@material-ui/icons/ArrowBackIosSharp';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardIosSharp';
import WarningIcon from '@material-ui/icons/WarningRounded';
// import EditIcon from '@material-ui/icons/Edit';
// import DeleteIcon from '@material-ui/icons/Delete';
// import AddIcon from '@material-ui/icons/Add';
// import CompareIcon from '@material-ui/icons/CompareArrows';
// import ListAltSharpIcon from '@material-ui/icons/List';
import CloseIcon from '@material-ui/icons/Close';
import ForwardIcon from '@material-ui/icons/Forward';
// import RaporMutu from '../RaporMutu/RaporMutu';

// import BadgeAward from '../../badgeAward';

const styles = theme => ({
    layoutRoot: {},
    indikatorLoading: {
        width: '100%',
        textAlign: 'center'
    },
    judulPertanyaan: {
        color: '#434343'
    },
    paperWarningSave : {
        borderRadius: 0,
        padding: 5,
        background: '#FFEB3B',
        color: 'black',
        textAlign: 'center',
        fontSize: '11px',
        position: 'absolute',
        width: '100%',
        zIndex: '999999',
        top: '65px',
        boxShadow: '0px 0px'
    },
    FabSimpan: {
        position: 'fixed',
        bottom: 25,
        right: 30,
        zIndex: 999999
    },
    panelPengawas: {
        background: '#eeeeee'
    },
    linearColorPrimary: {
        backgroundColor: '#b2dfdb',
    },
    linearBarColorPrimary: {
        backgroundColor: '#7CB342',
        // backgroundColor: '#00695c',
    },
    snackbarNotifikasi: {
        zIndex: 999999
    },
    paperKepsekIsiKuesioner: {
        background: '#E65100',
        borderRadius: '0px',
        color: 'white',
        textAlign: 'center'
    },
    textPaperKonfirmasiInstrumen: {
        color: 'white'
    },
});

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class LembarInstrumenR extends Component {
    state = {
        error: null,
        isLoaded: false,
        namaJudul: '',
        bottom: false,
        ListMenu: null,
        email: null,
        instrumen_id: null,
        tampilPertanyaan: (<div style={{textAlign: 'center', width: '100%'}}><CircularProgress/></div>),
        total: 0,
        nomor: 1,
        persentase: 0,
        tombolDisabled: false,
        canSubmit: false,
        checkedR: [],
        checkTes: true,
        tampilLoading: 'block',
        routeParams: {
            token: null,
            start: 0,
            limit: 20,
            pengguna_id: null,
            load_children: 0,
            tingkat_instrumen: 2,
            tahun_ajaran_id: localStorage.getItem('tahun'),
            kode: null,
            tahun: localStorage.getItem('tahun')
        },
        kuesionerInduk: {
            kode: '',
            judul: '',
            rows: [],
            total: 0
        },
        kuesionerNomor: {
            rows: [],
            total: 0
        },
        dialogOpen: false,
        dialogText: '',
        buttonDialogText: '',
        dialogUrl: '',
        SnackbarOpen1: false,
        SnackbarOpen2: false,
        snackbarText: '',
        checkRadio: []
    }

    radioTerpilih = (event) => {
        // alert(event.currentTarget.value);
        let jawaban = {};
        jawaban.ins_instrumen_id = event.currentTarget.name;
        jawaban.instrumen_id = event.currentTarget.value;
        jawaban.dirty = 1;
        jawaban.tipe_instrumen_id = 3;
        jawaban.pengguna_id = JSON.parse(localStorage.getItem('user')).pengguna_id;
        jawaban.induk_kode = this.props.location.pathname.split('/')[2];
        jawaban.nilai = 1;

        for (let index = 0; index < this.props.kuesioner.rows.length; index++) {
            const element = this.props.kuesioner.rows[index];

            if(element.ins_instrumen_id === event.currentTarget.name){
                // this.props.kuesioner.rows.splice(index, 1);
                this.props.kuesioner.rows[index].nilai = 0;
                this.props.kuesioner.rows[index].dirty = 1;
            }
            
            if(element.instrumen_id === event.currentTarget.value){
                this.props.kuesioner.rows.splice(index, 1);
                // this.props.kuesioner.rows[index].nilai = 0;
            }
            
        }

        this.props.kuesioner.rows.push(jawaban);
        this.props.kuesioner.total = this.props.kuesioner.rows.length;

        this.props.setKuesioner(this.props.kuesioner);
        this.props.setKuesionerDirty(1);

        // console.log(this.props.kuesioner);
    }

    handleSnackbarOpen = (type, text) => {
        if(type === 1){
            this.setState({ SnackbarOpen1: true, snackbarText: text });
        }else{
            this.setState({ SnackbarOpen2: true, snackbarText: text });
        }
    }

    handleSnackbarClose = (type) => (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        if(type === 1){
            this.setState({ SnackbarOpen1: false });
        }else{
            this.setState({ SnackbarOpen2: false });
        }
    };

    handleClickDialogOpen = (dialogText, buttonText, tipe) => {

        const mapNext = {
            'A' : 'B',
            'B' : 'C',
            'C' : 'D',
            'D' : 'E',
            'E' : 'F',
            'F' : null
        }

        const mapPrev = {
            'A' : null,
            'B' : 'A',
            'C' : 'B',
            'D' : 'C',
            'E' : 'D',
            'F' : 'E'
        }

        let url = null;
        
        // if(tipe === 'next'){
        //     url = '/TransisiInstrumen/'+mapNext[this.props.location.pathname.split('/')[2]]+'/1';
        // }else{
        //     url = '/TransisiInstrumen/'+mapPrev[this.props.location.pathname.split('/')[2]]+'/1';
        // }

        url = '/PerangkatKuesioner';

        this.setState({ 
            dialogOpen: true, 
            dialogText: dialogText, 
            buttonDialogText: buttonText,
            dialogUrl: url
        });

    };

    handleDialogClose = () => {
        this.setState({ dialogOpen: false });
    };

    getJenjangResponden = (sekolah, pengguna) => {
        let arrReturn = {};

        if(Number(pengguna.peran_id) === 10){
            arrReturn.responden = 'kepsek';
        }else if(Number(pengguna.peran_id) === 12 || Number(pengguna.peran_id) === 90){
            arrReturn.responden = 'siswa';
        }else if(Number(pengguna.peran_id) === 13){
            arrReturn.responden = 'pengawas';
        }else if(Number(pengguna.peran_id) === 14){
            arrReturn.responden = 'komite';
        }else if(Number(pengguna.peran_id) === 53){
            arrReturn.responden = 'guru';
        }
        
        if(Number(sekolah.bentuk_pendidikan_id) === 5){
            arrReturn.jenjang = 'SD';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 53){
            arrReturn.jenjang = 'SD';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 6){
            arrReturn.jenjang = 'SMP';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 54){
            arrReturn.jenjang = 'SMP';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 13){
            arrReturn.jenjang = 'SMA';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 55){
            arrReturn.jenjang = 'SMA';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 15){
            arrReturn.jenjang = 'SMK';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 29){
            arrReturn.jenjang = 'SLB';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 7){
            arrReturn.jenjang = 'SLB';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 8){
            arrReturn.jenjang = 'SLB';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 14){
            arrReturn.jenjang = 'SLB';
        }

        return arrReturn;
    }

    simpanKuesioner = () => {
        // alert('oke');
        this.props.setLoadingBesar(true);
        // console.log(this.props.kuesioner);
        // return true;
        this.props.setLoading('block');

        this.setState({
            ...this.state,
            routeParams: {
                ...this.state.routeParams,
                kuesioner: this.props.kuesioner,
                instrumen_id: localStorage.getItem('instrumen_id'),
                media_id: localStorage.getItem('tipe_app'),
                jenjang: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).jenjang,
                responden: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).responden
            }
        }, () => {
            // console.log(this.state.routeParams);return true;
            this.props.simpanKuesioner(this.state.routeParams).then((result)=>{
                // console.log(this.props.kuesioner.rows.length);

                this.props.setLoading('none');
                this.props.setLoadingBesar(false);

                let kelompokKodeDirty = [];
                for (let indexKuesioner = 0; indexKuesioner < this.props.kuesioner.rows.length; indexKuesioner++) {
                    const element = this.props.kuesioner.rows[indexKuesioner];
                    // console.log(element);
                    // kelompokKodeDirty = kelompokKodeDirty + "," + element.induk_kode;
                    // kelompokKodeDirty.push(element.induk_kode);
                    if(element.dirty === 1){
                        let jmlCari = 0;
                        for (let indexCari = 0; indexCari < kelompokKodeDirty.length; indexCari++) {
                            const elementCari = kelompokKodeDirty[indexCari];
    
                            if(elementCari === element.induk_kode){
                                jmlCari++;
                            }
                        }
    
                        if(jmlCari === 0){
                            kelompokKodeDirty.push(element.induk_kode);
                        }
                    }

                }

                // console.log(JSON.stringify(kelompokKodeDirty));
                // return true;

                this.props.setKuesionerDirty(0);
                this.handleSnackbarOpen(1, 'Jawaban berhasil disimpan!');
                this.props.setActiveStep(1);
                // this.handleClickDialogOpen('Jawaban Berhasil Disimpan', 'Kembali ke kategori sebelumnya');
                // console.log(this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))));

                this.setState({
                    ...this.state,
                    routeParams: {
                        ...this.state.routeParams,
                        tingkat_instrumen: 1,
                        kode: null,
                        induk_kode: null,
                        ins_instrumen_id: null,
                        kuesioner: null,
                        load_children: 1,
                        limit: 100,
                        start: 0,
                        jenjang: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).jenjang,
                        responden: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).responden,
                        kelompok_kode: JSON.stringify(kelompokKodeDirty),
                        sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
                        pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id
                    }
                },()=>{
                    // this.handleSnackbarOpen(2, 'Sinkronisasi progres pengisian ...');
                    // this.props.hitungRekapKemajuan(this.state.routeParams);
                    // this.props.getSemuaBadge(this.state.routeParams).then((result)=>{
                        
                    //     // console.log(this.props.toggle_badge);
                    //     for (let index = 0; index < this.props.semua_badge.length; index++) {
                    //         const element = this.props.semua_badge[index];

                    //         // console.log(element);
                    //         if(element.status === 'akhirnya_dapat'){
                    //             this.props.toggle_badge[element.jenis_badge_id] = true;

                    //             this.props.setBadgePengguna(this.state.routeParams, element.jenis_badge_id)
                    //         }
                            
                    //     }
                    //     this.props.toggleBadgeOpen(this.props.toggle_badge);
                    // });
                });
                
            });
        })

    }

    toggleDrawer = (side, open, option) => () => {
        this.setState({ ...this.state, [side]: open });
    }

    goTolink = (url) => {
        this.props.history.push(url);
        // alert('oke ganti');
    };

    halamanSebelumnya = () => {
        if(Number(this.state.nomor) > 1){
            // this.state.nomor = Number(this.state.nomor, 10)-1;
            this.setState({
                nomor: Number(this.state.nomor, 10)-1
            },()=>{

                this.props.history.push('/TransisiInstrumen/'+this.props.location.pathname.split('/')[2]+'/'+this.state.nomor);
                // this.props.history.push('/LembarInstrumen/'+this.props.location.pathname.split('/')[2]+'/'+this.state.nomor);
    
                this.setState({
                    ...this.state,
                    routeParams:  {
                        ...this.state.routeParams,
                        start: (this.state.nomor-1)
                    },
                    persentase: ( Math.round(this.state.nomor/Number(this.props.fetch_kuesioner.total, 10)*100) ),
                    tombolDisabled: true,
                    tampilLoading: 'block'
                }, () => {
                    this.props.getKuesioner(this.state.routeParams).then((result)=>{
                        this.setState({
                            ...this.state,
                            kuesionerNomor: result.payload.rows[0].children
                        });
    
                        this.setState({
                            tombolDisabled: false,
                            tampilLoading: 'none'
                        });     
                        
                        this.setTampilanKuesioner(this.props.fetch_kuesioner.rows[0]);
                    });
                })

            })

        }else{
            // alert('halaman paling awal');
            this.handleClickDialogOpen('Ini adalah nomor pertama pada kategori ini', 'Kembali ke Menu Utama', 'prev');
            // this.handleClickDialogOpen('Ini adalah nomor pertama pada kategori ini', 'Kembali ke kategori sebelumnya', 'prev');
        }
    }

    halamanBerikutnya = () => {
        console.log(this.props.fetch_kuesioner.total);
        console.log(this.state.nomor);
        

        if(Number(this.state.nomor) < Number(this.props.fetch_kuesioner.total)){
            // this.setState({
            //     tombolDisabled: true
            // });

            // this.state.nomor = Number(this.state.nomor, 10)+1;
            this.setState({
                nomor: Number(this.state.nomor, 10)+1
            },()=>{
                // console.log(this.state.nomor)
                this.props.history.push('/TransisiInstrumen/'+this.props.location.pathname.split('/')[2]+'/'+this.state.nomor);
                // this.props.history.push('/LembarInstrumen/'+this.props.location.pathname.split('/')[2]+'/'+this.state.nomor);
    
                this.setState({
                    ...this.state,
                    routeParams:  {
                        ...this.state.routeParams,
                        start: (this.state.nomor-1)
                    },
                    persentase: ( Math.round(this.state.nomor/Number(this.props.fetch_kuesioner.total, 10)*100) ),
                    tombolDisabled: true,
                    tampilLoading: 'block'
                }, () => {
                    this.props.getKuesioner(this.state.routeParams).then((result)=>{
                        this.setState({
                            ...this.state,
                            kuesionerNomor: result.payload.rows[0].children
                        });
    
                        this.setState({
                            tombolDisabled: false,
                            tampilLoading: 'none'
                        });    
                        
                        this.setTampilanKuesioner(this.props.fetch_kuesioner.rows[0]);
                    });
                })
                
            });
            
            // return true
            // this.setState({
            //     persentase: ( Math.round(this.state.nomor/Number(this.props.fetch_kuesioner.total)*100) ),
            //     tombolDisabled: true,
            //     tampilLoading: 'block'
            // });



        }else{
            // alert('halaman terakhir');
            this.handleClickDialogOpen('Anda telah sampai di pertanyaan terakhir pada kategori ini', 'Kembali ke Menu Utama', 'next');
            // this.handleClickDialogOpen('Anda telah sampai di pertanyaan terakhir pada kategori ini', 'Lanjut ke kategori selanjutnya', 'next');
        }
    }

    setTampilanKuesioner = (rows) => {

        if(Number(rows.a_pertanyaan) === 1){
            // console.log('langsung pertanyaan');

            for (let indexJawaban = 0; indexJawaban < rows.children.rows.length; indexJawaban++) {
                const elementJawaban = rows.children.rows[indexJawaban];
                // console.log(elementJawaban);

                if(elementJawaban.jawaban_id !== null){

                    if(typeof this.props.kuesioner.rows.find(x => x.instrumen_id === elementJawaban.instrumen_id) !== 'undefined'){
                        // donothing
                    }else{
                        let jawaban = {};
                        jawaban.jawaban_id = elementJawaban.jawaban_id;
                        jawaban.instrumen_id = elementJawaban.instrumen_id;
                        jawaban.pengguna_id = elementJawaban.pengguna_id;
                        jawaban.induk_kode = this.props.location.pathname.split('/')[2];
                        jawaban.nilai = elementJawaban.nilai;
                        jawaban.tipe_instrumen_id = elementJawaban.tipe_instrumen_id;
                        jawaban.ins_instrumen_id = elementJawaban.ins_instrumen_id;
                        jawaban.abstain = elementJawaban.abstain;
                        
                        this.props.kuesioner.rows.push(jawaban);
                        this.props.kuesioner.total = this.props.kuesioner.rows.length;
                    }


                    // for (let index = 0; index < this.props.kuesioner.rows.length; index++) {
                    //     const element = this.props.kuesioner.rows[index];
                        
                    //     if(element.instrumen_id === elementJawaban.instrumen_id){
                    //         this.props.kuesioner.rows.splice(index, 1);
                    //     }
                        
                    // }


                }

            }
        }else{
            // console.log(rows);

            for (let index = 0; index < rows.children.rows.length; index++) {
                const element = rows.children.rows[index];

                if(Number(element.a_pertanyaan) === 1){
                    // console.log(element);

                    for (let indexJawaban = 0; indexJawaban < element.children.rows.length; indexJawaban++) {
                        const elementJawaban = element.children.rows[indexJawaban];
                        // console.log(elementJawaban);

                        if(elementJawaban.jawaban_id !== null){

                            if(typeof this.props.kuesioner.rows.find(x => x.instrumen_id === elementJawaban.instrumen_id) !== 'undefined'){
                                // donothing
                            }else{
                                let jawaban = {};
                                jawaban.jawaban_id = elementJawaban.jawaban_id;
                                jawaban.instrumen_id = elementJawaban.instrumen_id;
                                jawaban.pengguna_id = elementJawaban.pengguna_id;
                                jawaban.induk_kode = this.props.location.pathname.split('/')[2];
                                jawaban.nilai = elementJawaban.nilai;
                                jawaban.tipe_instrumen_id = elementJawaban.tipe_instrumen_id;
                                jawaban.ins_instrumen_id = elementJawaban.ins_instrumen_id;
                                jawaban.abstain = elementJawaban.abstain;
                                
                                this.props.kuesioner.rows.push(jawaban);
                                this.props.kuesioner.total = this.props.kuesioner.rows.length;
                            }
        

                            // for (let index = 0; index < this.props.kuesioner.rows.length; index++) {
                            //     const element = this.props.kuesioner.rows[index];
                                
                            //     if(element.instrumen_id === elementJawaban.instrumen_id){
                            //         this.props.kuesioner.rows.splice(index, 1);
                            //     }
                                
                            // }


                        }

                    }
                }else{
                    // console.log(element);
                    for (let indexSub = 0; indexSub < element.children.rows.length; indexSub++) {
                        const elementSub = element.children.rows[indexSub];

                        for (let indexJawaban = 0; indexJawaban < elementSub.children.rows.length; indexJawaban++) {
                            const elementJawaban = elementSub.children.rows[indexJawaban];
                            
                            if(elementJawaban.jawaban_id !== null){

                                if(typeof this.props.kuesioner.rows.find(x => x.instrumen_id === elementJawaban.instrumen_id) !== 'undefined'){
                                    // donothing
                                }else{
                                    let jawaban = {};
                                    jawaban.jawaban_id = elementJawaban.jawaban_id;
                                    jawaban.instrumen_id = elementJawaban.instrumen_id;
                                    jawaban.pengguna_id = elementJawaban.pengguna_id;
                                    jawaban.induk_kode = this.props.location.pathname.split('/')[2];
                                    jawaban.nilai = elementJawaban.nilai;
                                    jawaban.tipe_instrumen_id = elementJawaban.tipe_instrumen_id;
                                    jawaban.ins_instrumen_id = elementJawaban.ins_instrumen_id;
                                    jawaban.abstain = elementJawaban.abstain;
                                    
                                    this.props.kuesioner.rows.push(jawaban);
                                    this.props.kuesioner.total = this.props.kuesioner.rows.length;
                                }
            
    
                                // for (let index = 0; index < this.props.kuesioner.rows.length; index++) {
                                //     const element = this.props.kuesioner.rows[index];
                                    
                                //     if(element.instrumen_id === elementJawaban.instrumen_id){
                                //         this.props.kuesioner.rows.splice(index, 1);
                                //     }
                                    
                                // }
    
    
                            }
                        }

                        // console.log('sub pertanyaan => sub sub => jawaban');

                        
                    }

                }
                
            }
        }

        this.props.setKuesioner(this.props.kuesioner);
        this.props.setRadioKuesioner(this.props.kuesioner);
    }

    componentDidMount = () => {
        
        console.log(this.props.location.pathname.split('/')[3])

        // this.setState({
        //     checkRadio: {
        //         "38034648-5652-44ee-84ea-a01b3fd033e8" : '4ced2229-5e6d-4f23-8edf-937dbe8befd6'
        //     }
        // });

        // window.onscroll = function() {
        //     if(window.pageYOffset === 0) {
        //       alert('I AM AT THE TOP');
        //     }
        // };
        // const node = ReactDOM.findDOMNode(this);
        // console.log(node);

        // if(typeof this.props.location.pathname.split('/')[3] !== 'undefined') {
        //     // this.state.nomor = this.props.location.pathname.split('/')[3];
        //     this.setState({
        //         nomor: this.props.location.pathname.split('/')[3]
        //     })
        // }
        
        this.setState({
            ...this.state,
            nomor: (typeof this.props.location.pathname.split('/')[3] !== 'undefined' ? this.props.location.pathname.split('/')[3] : this.state.nomor),
            routeParams: {
                ...this.state.routeParams,
                sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
                pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
                token: localStorage.getItem('jwt_token'),
                // nomor: this.props.location.pathname.split('/')[3] ? this.props.location.pathname.split('/')[3] : this.state.nomor
                // nomor: (typeof this.props.location.pathname.split('/')[3] !== 'undefined' ? this.props.location.pathname.split('/')[3] : this.state.nomor)
            }
        }, ()=>{
            // this.props.getKonfirmasiSelesai(this.state.routeParams).then((result)=>{
            //     // this.props.setKunciKonfirmasiInstrumen(this.props.konfirmasi_instrumen.konfirmasi_instrumen_id);
            // });
            console.log(this.state.nomor)

            this.props.getKemajuanTotal(this.state.routeParams).then((result)=>{
                // let ceks = 0;
                // const user = JSON.parse(localStorage.getItem('user'));

                // this.props.kemajuan_total.rows.map((option)=>{
                //     if(Number(option.peran_id) === 99){
                //         this.setState({
                //             ...this.state,
                //             kemajuan_total: option.persentase
                //         });
                //     }

                //     if(Number(option.peran_id) === 53 && option.persentase === 100){
                //         ceks++;
                //     }

                //     if(Number(option.peran_id) === 90 && option.persentase === 100){
                //         ceks++;
                //     }

                //     if(Number(option.peran_id) === 14 && option.persentase === 100){
                //         ceks++;
                //     }
                // });

                // console.log(ceks);
                // if(Number(user.peran_id) === 10){
                //     if(ceks === 3){
                //         this.props.setKepsekIsiKuesioner(true);
                //     }else{
                //         this.props.setKepsekIsiKuesioner(true);
                //         // this.props.setKepsekIsiKuesioner(false);
                //         // this.props.setKunciKonfirmasiInstrumen('kuncian_kepsek');
                //     }
                // }
            })

            this.props.getSekolah(this.state.routeParams).then((result)=>{

                // console.log(this.props.sekolah);
                // let peranResponden = 'kepsek';
                // let jenjangResponden = 'SD';

                // if(this.props.sekolah.peran_id === 10){
                //     peranResponden = 'kepsek';
                // }else if(this.props.sekolah.peran_id === 12){
                //     peranResponden = 'siswa';
                // }else if(this.props.sekolah.peran_id === 13){
                //     peranResponden = 'pengawas';
                // }else if(this.props.sekolah.peran_id === 14){
                //     peranResponden = 'komite';
                // }else if(this.props.sekolah.peran_id === 53){
                //     peranResponden = 'guru';
                // }

                // if(this.props.Number(sekolah.bentuk_pendidikan_id) === 5){
                //     jenjangResponden = 'SD';
                // }else if(this.props.Number(sekolah.bentuk_pendidikan_id) === 6){
                //     jenjangResponden = 'SMP';
                // }else if(this.props.Number(sekolah.bentuk_pendidikan_id) === 13){
                //     jenjangResponden = 'SMA';
                // }else if(this.props.Number(sekolah.bentuk_pendidikan_id) === 15){
                //     jenjangResponden = 'SMK';
                // }else if(this.props.Number(sekolah.bentuk_pendidikan_id) === 29){
                //     jenjangResponden = 'SLB';
                // }else if(Number(sekolah.bentuk_pendidikan_id) === 7){
                //     arrReturn.jenjang = 'SLB';
                // }else if(Number(sekolah.bentuk_pendidikan_id) === 8){
                //     arrReturn.jenjang = 'SLB';
                // }else if(Number(sekolah.bentuk_pendidikan_id) === 14){
                //     arrReturn.jenjang = 'SLB';
                // }


                this.setState({
                    ...this.state,
                    routeParams: {
                        ...this.state.routeParams,
                        token: localStorage.getItem('jwt_token'),
                        pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
                        kode: this.props.location.pathname.split('/')[2],
                        jenjang: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).jenjang,
                        responden: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).responden
                    }
                }, () => {
                    // this.state.kuesionerInduk  = this.props.getKuesioner(this.state.routeParams);
                    
                    this.props.getKuesioner(this.state.routeParams).then((result)=>{
                        // console.log(result.payload);
                        this.setState({
                            ...this.state,
                            kuesionerInduk: result.payload.rows[0],
                            instrumen_id: result.payload.rows[0].instrumen_id
                        }, () => {
                            this.setState({
                                ...this.state,
                                routeParams: {
                                    ...this.state.routeParams,
                                    start: (this.state.nomor-1),
                                    limit: 1,
                                    load_children: 1,
                                    ins_instrumen_id: this.state.instrumen_id,
                                    jenjang: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).jenjang,
                                    responden: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).responden,
                                    induk_kode: this.props.location.pathname.split('/')[2],
                                    kode: null
                                }
                            }, () => {
                                this.props.setJudul(this.state.kuesionerInduk.kode+ ". " +this.state.kuesionerInduk.judul);
                                
                                this.props.getKuesioner(this.state.routeParams).then((result)=>{

                                    this.setState({
                                        ...this.state,
                                        kuesionerNomor: result.payload.rows[0].children,
                                        persentase: ( Math.round(this.state.nomor/Number(this.props.fetch_kuesioner.total, 10)*100) ),
                                        tampilLoading: 'none'
                                    },()=>{

                                        let checkRadio = {}

                                        this.state.kuesionerNomor.rows.map((option)=>{

                                            if(Number(option.nilai) === 1){
                                                // console.log(option);
                                                // this.state.checkRadio[option.ins_instrumen_id] = option.instrumen_id;
                                                // this.setState({
                                                //     checkRadio: {
                                                //         ...this.state.checkRadio,
                                                //         [option.ins_instrumen_id]: option.instrumen_id
                                                //     }
                                                // })

                                                checkRadio[option.ins_instrumen_id] = option.instrumen_id
                                            }

                                        })

                                        this.setState({
                                            ...this.state,
                                            checkRadio: checkRadio
                                        },()=>{

                                            // console.log(this.props.fetch_kuesioner);
                                            // console.log(this.state.kuesionerNomor);
        
                                            // this.setState({
                                            // });
        
                                            // console.log(this.props.fetch_kuesioner.rows);
        
                                            this.setTampilanKuesioner(this.props.fetch_kuesioner.rows[0]);
                                            // this.props.setKuesioner(this.props.kuesioner);
        
                                            let checkRadio = [];
                                            // console.log(this.state.checkRadio);
                                            for (let index = 0; index < this.props.kuesioner.rows.length; index++) {
                                                const element = this.props.kuesioner.rows[index];
        
                                                if(Number(element.tipe_instrumen_id) === 3 && Number(element.nilai) === 1){
                                                    // console.log(element);
                                                    checkRadio[element.ins_instrumen_id] = element.instrumen_id;
                                                }
                                            }
        
                                            // if(this.props.fetch_kuesioner.rows[0].a_pertanyaan === 1){
                                            //     console.log('langsung pertanyaan');
                                            // }else{
                                            //     for (let index = 0; index < this.props.fetch_kuesioner.rows[0].children.rows.length; index++) {
                                            //         const element = this.props.fetch_kuesioner.rows[0].children.rows[index];
        
                                            //         if(element.a_pertanyaan === 1){
                                            //             // console.log(element);
        
                                            //             for (let indexJawaban = 0; indexJawaban < element.children.rows.length; indexJawaban++) {
                                            //                 const elementJawaban = element.children.rows[indexJawaban];
                                            //                 // console.log(elementJawaban);
        
                                            //                 if(elementJawaban.jawaban_id !== null){
                                            //                     let jawaban = {};
                                            //                     jawaban.jawaban_id = elementJawaban.jawaban_id;
                                            //                     jawaban.instrumen_id = elementJawaban.instrumen_id;
                                            //                     jawaban.pengguna_id = elementJawaban.pengguna_id;
                                            //                     jawaban.nilai = elementJawaban.nilai;
                                                                
                                            //                     this.props.kuesioner.rows.push(jawaban);
                                            //                     this.props.kuesioner.total = this.props.kuesioner.rows.length;
                                            //                 }
        
                                            //             }
                                            //         }else{
        
                                            //             for (let indexSub = 0; indexSub < element[index].children.rows.length; indexSub++) {
                                            //                 const elementSub = element[index].children.rows[indexSub];
        
                                            //                 console.log('sub pertanyaan => sub sub => jawaban');
                                                            
                                            //             }
        
                                            //         }
                                                    
                                            //     }
                                            // }
        
                                            // this.props.setKuesioner(this.props.kuesioner);
                                            // console.log(this.props.kuesioner);

                                        })

                                    });
                                    
                                });

                            })
                            
                        });
                        // console.log(this.state.kuesionerInduk);
                    });
                    // setTimeout(() => {
                    //     console.log(this.state.kuesionerInduk);
                    // }, 5000);

                    // this.setState({
                    //     ...this.state,
                    //     kuesionerInduk: this.props.fetch_kuesioner
                    // }, function(){
                    //     // console.log(this.state.kuesionerInduk);
                    //     console.log(this.state);
                    // });
                });

            });
        });

    };

    render()
    {
        const {classes} = this.props;
        const {bottom, ListMenu} = this.state;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                content={
                    <div style={{width: '100%', paddingBottom: '70px'}} className="kontenUtama" ref={div => (this.div = div)} onScroll={()=>{console.log('tes')}}>
                        {/* <Fab variant="extended" aria-label="Delete" className={classes.fab}>
                            <SaveIcon className={classes.extendedIcon} />
                            Simpan
                        </Fab> */}
                        {/* <BadgeAward jenis_badge_id={1}/>
                        <BadgeAward jenis_badge_id={2}/>
                        <BadgeAward jenis_badge_id={3}/>
                        <BadgeAward jenis_badge_id={4}/>
                        <BadgeAward jenis_badge_id={5}/>
                        <BadgeAward jenis_badge_id={6}/>
                        <BadgeAward jenis_badge_id={7}/>
                        <BadgeAward jenis_badge_id={8}/>
                        <BadgeAward jenis_badge_id={9}/> */}
                        <Button variant="extendedFab" className="FabSimpan" color="primary" size="small" onClick={()=>{this.halamanSebelumnya()}} disabled={this.state.tombolDisabled} style={{marginRight: 170, minWidth: '50px'}}>
                            <ArrowBackIcon />
                            {/* <Typography style={{color:'white'}}></Typography> */}
                        </Button>
                        {this.props.kepsek_isi_kuesioner === false && <Button disabled variant="extendedFab" className="FabSimpan" onClick={this.simpanKuesioner} style={{marginRight: 55}}>
                            <SaveIcon className={classes.extendedIcon} />
                            Simpan
                        </Button>}
                        {this.props.kepsek_isi_kuesioner === true && <Button variant="extendedFab" className="FabSimpan" onClick={this.simpanKuesioner} style={{marginRight: 55}}>
                            <SaveIcon className={classes.extendedIcon} />
                            Simpan
                        </Button>}
                        {/* <Button variant="extendedFab" className="FabSimpan" onClick={this.simpanKuesioner} style={{marginRight: 55}}>
                            <SaveIcon className={classes.extendedIcon} />
                            Simpan
                        </Button> */}
                        <Button variant="extendedFab" className="FabSimpan" color="primary" size="small" onClick={()=>{this.halamanBerikutnya()}} disabled={this.state.tombolDisabled} style={{minWidth: '50px'}}>
                            <ArrowForwardIcon />
                            {/* <Typography style={{color:'white'}}></Typography> */}
                        </Button>
                        <div className="p-16" style={{border: '0px solid #ccc', width: '100%', backgroundImage: 'url(http://'+window.location.host+'/assets/images/backgrounds/library.jpg)', marginTop: '-1px', backgroundPosition: 'center', backgroundSize: 'cover', minHeight: 89}}>
                            <Grid container spacing={16}>
                                <Grid item xs={10} sm={9} style={{paddingLeft: 10}}>
                                    <h1 style={{fontSize: 25, fontFamily: 'Helvetica', color: 'white'}}>{this.state.kuesionerInduk.kode}. {this.state.kuesionerInduk.judul}</h1>
                                </Grid>
                                <Grid item xs={2} sm={3} style={{textAlign: 'right'}}>
                                {this.props.dirty === 1 &&
                                    <Badge badgeContent={<WarningIcon style={{color: '#F50002'}}/>} className={classes.margin + " badgeDirty"} style={{marginRight: 10}}>
                                        <Button size="small" variant="contained" style={{margin: 'auto', marginRight: 0}} color="primary" className="buttonTambah" onClick={this.simpanKuesioner} >
                                            <SaveIcon /> Simpan
                                        </Button>
                                    </Badge>
                                }
                                {this.props.dirty === 0 && this.props.kepsek_isi_kuesioner === true &&
                                    <Button size="small" variant="contained" style={{margin: 'auto', marginRight: 10}} color="primary" className="buttonTambah" onClick={this.simpanKuesioner} >
                                        <SaveIcon /> Simpan
                                    </Button>
                                }
                                {this.props.dirty === 0 && this.props.kepsek_isi_kuesioner === false &&
                                    <Button disabled size="small" variant="contained" style={{margin: 'auto', marginRight: 10}} color="primary" className="buttonTambah" onClick={this.simpanKuesioner} >
                                        <SaveIcon /> Simpan
                                    </Button>
                                }
                                    {/* <Button size="small" variant="contained" style={{margin: 'auto', minWidth: '40px'}} color="primary" className="buttonMenu" onClick={this.bukaMenuUtama}>
                                        <MenuIcon style={{color:'white'}} />
                                    </Button> */}
                                </Grid>
                            </Grid>
                        </div>

                        <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '42px', display: 'inline-flex'}}>
                            <Chip
                                icon={<HomeIcon/>}
                                label=""
                                className={this.props.classes.chip}
                                color="primary"
                                style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                onClick={()=>{this.goTolink('/Beranda')}}
                                />
                            <Chip
                                label="> Perangkat Kuesioner"
                                className={this.props.classes.chip}
                                color="primary"
                                onClick={()=>{this.goTolink('/PerangkatKuesioner')}}
                                style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                            />
                            <Chip
                                label={"> "+this.state.kuesionerInduk.kode + ". "  + this.state.kuesionerInduk.judul}
                                className={this.props.classes.chip}
                                color="secondary"
                                // onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                                style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                            />
                        </div>
                        
                        {this.props.dirty === 1 &&
                        <Paper className={classes.paperWarningSave + " paperWarningSave"}>
                            <WarningIcon style={{fontSize: '12px'}}/> Terdapat jawaban yang belum tersimpan. Segera klik tombol simpan untuk menghindari hilangnya jawaban Anda!
                        </Paper>
                        }
                        <LinearProgress 
                            style={{height:10}} 
                            variant="determinate" 
                            value={this.state.persentase} 
                            classes={{
                                colorPrimary: classes.linearColorPrimary,
                                barColorPrimary: classes.linearBarColorPrimary,
                            }}
                        />
                        <Paper className="p-16">
                            {/* <Button variant="contained" color="primary" size="small">
                                <ArrowBackIcon />
                            </Button> */}
                            <Grid container>
                                <Grid item xs={2} sm={3}>
                                    <IconButton variant="contained" color="primary" size="small" onClick={()=>{this.halamanSebelumnya()}} disabled={this.state.tombolDisabled}>
                                        <ArrowBackIcon />
                                        {/* <Typography style={{color:'white'}}></Typography> */}
                                    </IconButton>
                                </Grid>
                                <Grid item xs={8} sm={6} style={{textAlign: 'center'}}>
                                    Nomor <b>{this.state.nomor}</b> dari <b>{this.props.fetch_kuesioner.total}</b>
                                </Grid>
                                <Grid item xs={2} sm={3} style={{textAlign: 'right'}}>
                                    <IconButton variant="contained" color="primary" size="small" onClick={()=>{this.halamanBerikutnya()}} disabled={this.state.tombolDisabled}>
                                        {/* <Typography style={{color:'white'}}></Typography> */}
                                        <ArrowForwardIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Paper>
                        {this.props.kepsek_isi_kuesioner !== true &&
                        <Paper className={"p-8 " + classes.paperKepsekIsiKuesioner}>
                            <Typography variant="subheading" className={classes.textPaperKonfirmasiInstrumen}>
                                <span style={{fontSize: '20px', fontWeight: 'bold'}}>Anda sebagai kepala sekolah belum bisa mengisi kuesioner</span><br/>
                                <Typography style={{fontSize: '12px', color:'white'}}>Sebagai kepala sekolah, Anda baru bisa mengisi kuesioner setelah Guru, Peserta Didik, dan Komite telah selesai mengisi kuesioner sesuai dengan jumlah responden minimalnya</Typography>
                                {/* <Typography style={{fontSize: '12px', color:'white'}}>Untuk mengecek kemajuan masing-masing reponden, silakan buka menu ini</Typography> */}
                            </Typography>
                        </Paper>
                        }
                        <Grid container>
                            <Grid item xs={12} sm={12}>
                                <div className="p-16">
                                    <div className={classes.indikatorLoading} style={{display: this.state.tampilLoading}}>
                                        <LinearProgress />
                                    </div>
                                    <Formsy
                                        onValidSubmit={this.onSubmit}
                                        onValid={this.enableButton}
                                        onInvalid={this.disableButton}
                                        ref={(form) => this.form = form}
                                        className="flex flex-col justify-center"
                                    >
                                        {this.props.fetch_kuesioner.rows.map((optionInduk)=>(
                                            <Card key={optionInduk.instrumen_id}>
                                                <CardHeader
                                                title={optionInduk.kode + ". " + optionInduk.judul}
                                                classes={{
                                                    title: classes.judulPertanyaan
                                                }}
                                                />
                                                <CardContent>  
                                                    
                                                    {Number(optionInduk.a_pertanyaan) === 1 && Number(optionInduk.tipe_instrumen_id) === 3 &&
                                                        <RadioGroupFormsy
                                                        name={optionInduk.instrumen_id}
                                                        // value="4ced2229-5e6d-4f23-8edf-937dbe8befd6"
                                                        value={this.state.checkRadio[optionInduk.instrumen_id]}
                                                        required
                                                        >
                                                        {/* {(Number(JSON.parse(localStorage.getItem('user')).peran_id) === 13 || Number(JSON.parse(localStorage.getItem('user')).peran_id) === 10) && */}
                                                        {/* <Paper className="p-8" style={{width:'100%', fontSize:'12px', fontStyle:'italic', color:'#9e9e9e'}}>{optionInduk.deskripsi}</Paper> */}
                                                            {/* <Paper className="p-8" style={{width:'100%'}}>Pilihan mayoritas responden sekolah: (jawaban)</Paper> */}
                                                        {/* } */}
                                                        {this.state.kuesionerNomor.rows.map((option)=>{
                                                            // for (let index = 0; index < this.props.kuesioner.rows.length; index++) {
                                                                //     const element = this.props.kuesioner.rows[index];
                                                                
                                                                // if(Number(option.nilai) === 1){
                                                                //     // console.log(option);
                                                                //     // this.state.checkRadio[option.ins_instrumen_id] = option.instrumen_id;
                                                                //     this.setState({
                                                                //         checkRadio: {
                                                                //             ...this.state.checkRadio,
                                                                //             [option.ins_instrumen_id]: option.instrumen_id
                                                                //         }
                                                                //     })
                                                                // }
                                                            //         // console.log(element);
                                                            //     }
                                                                
                                                            // }
                                                            // console.log(this.state.checkRadio[optionInduk.instrumen_id]);
                                                            // // console.log(this.props.kuesioner);
                                                            
                                                            // // this.props.setKuesioner(this.props.kuesioner);
                                                            // // this.props.setKuesionerDirty(1);

                                                            return (
                                                                <FormControlLabel 
                                                                    className="radioKuesioner" 
                                                                    value={option.instrumen_id} 
                                                                    key={option.instrumen_id} 
                                                                    control={<Radio color="primary"/>} 
                                                                    label={option.judul}
                                                                    onChange={this.radioTerpilih}   
                                                                />
                                                            )
                                                            // return(
                                                                
                                                            //     <PanelPertanyaan 
                                                            //         judul={option.judul} 
                                                            //         poinPertanyaan={option}
                                                            //         key={option.instrumen_id}
                                                            //     />
                                                                
                                                            // )})}
                                                        })}
                                                        </RadioGroupFormsy>
                                                    }
                                                    {Number(optionInduk.a_pertanyaan) === 1 && Number(optionInduk.tipe_instrumen_id) === 2 &&
                                                        <div>
                                                            {/* okesip */}
                                                            {this.state.kuesionerNomor.rows.map((option)=>{
                                                            // console.log(this.state.kuesionerNomor);
                                                            return(
                                                                
                                                                <PanelPertanyaan 
                                                                    judul={option.judul} 
                                                                    poinPertanyaan={option}
                                                                    tipeInduk={optionInduk.tipe_instrumen_id}
                                                                    key={option.instrumen_id}
                                                                />
                                                                
                                                            )})}
                                                            {/* <Paper className="p-8" style={{width:'100%', fontSize:'12px', fontStyle:'italic', color:'#9e9e9e'}}>{optionInduk.deskripsi}</Paper> */}
                                                        </div>
                                                    }
                                                    {/* {Number(optionInduk.a_pertanyaan) === 1 && Number(optionInduk.tipe_instrumen_id) === 1 &&
                                                        <div>
                                                            
                                                            <TextField
                                                                id={"isian_"+option.instrumen_id}
                                                                label="........."
                                                                // disabled={this.state.isian['disabled_'+option.instrumen_id]}
                                                                // label={option.judul}
                                                                className={classes.textField}
                                                                value={this.state.isian["isian_"+option.instrumen_id]}
                                                                onChange={this.handleChange("isian_"+option.instrumen_id, option.instrumen_id, option.ins_instrumen_id)}
                                                                margin="dense"
                                                                style={{width: '100%'}}
                                                                variant="outlined"
                                                                disabled={this.state.kunci_konfirmasi_instrumen}
                                                            />                                                            
                                                        </div>
                                                    } */}
                                                    {Number(optionInduk.a_pertanyaan) === 0 && 
                                                        <div>
                                                            {this.state.kuesionerNomor.rows.map((option)=>{
                                                            // console.log(this.state.kuesionerNomor);
                                                            return(
                                                                
                                                                <PanelPertanyaan 
                                                                    judul={option.judul} 
                                                                    poinPertanyaan={option}
                                                                    tipeInduk={optionInduk.tipe_instrumen_id}
                                                                    key={option.instrumen_id}
                                                                />
                                                                
                                                            )})}
                                                        </div>
                                                    }
                                                    <Paper className="p-8" style={{width:'100%', fontSize:'12px', fontStyle:'italic', color:'#434343'}}>
                                                        <b>Keterangan:</b>
                                                        <br/>
                                                        {optionInduk.deskripsi}
                                                    </Paper>
                                                </CardContent>
                                            </Card>
                                        ))}
                                    </Formsy>
                                </div>
                            </Grid>
                            {/* <Grid item xs={12} sm={4} className="p-16">
                                <Paper>
                                    <Typography variant="subheading" className="p-16">
                                        Daftar Pertanyaan
                                    </Typography>
                                    <List>
                                        {this.state.kuesionerNomor.rows.map((option)=>{
                                        
                                        this.state['colorIcon_'+option.instrumen_id] = '#cccccc';
                                        
                                        return (
                                            <ListItem button>
                                                <Grid container>
                                                        <Grid item xs={11} sm={11}>
                                                            {option.nomor_urut}. {option.judul}
                                                        </Grid>
                                                        <Grid item xs={1} sm={1}>
                                                            <CheckCircleIcon style={{color:this.state['colorIcon_'+option.instrumen_id]}}/>
                                                        </Grid>
                                                </Grid>
                                            </ListItem>
                                        )
                                        })}
                                    </List>
                                </Paper>
                            </Grid> */}
                        </Grid>
                        <SwipeableDrawer
                            anchor="bottom"
                            open={bottom}
                            onClose={this.toggleDrawer('bottom', false, null)}
                            onOpen={this.toggleDrawer('bottom', true, null)}
                        >
                            <div style={{padding: 0, minHeight: 100, maxHeight: 400, overflow: 'auto'}}>
                                {ListMenu}
                            </div>
                        </SwipeableDrawer>
                        <Dialog
                            open={this.state.dialogOpen}
                            TransitionComponent={Transition}
                            keepMounted
                            onClose={this.handleDialogClose}
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogContent>
                                <DialogContentText>
                                    {this.state.dialogText}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleDialogClose}>
                                    <CloseIcon/> Tutup
                                </Button>
                                <Button onClick={()=>this.goTolink(this.state.dialogUrl)}>
                                    <ForwardIcon/> {this.state.buttonDialogText}
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Snackbar
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            style={{zIndex:999999,bottom: (this.props.window_dimension.width <= 425) ? '58px' : '20px'}}
                            classes={this.snackbarNotifikasi}
                            open={this.state.SnackbarOpen1}
                            autoHideDuration={500000}
                            onClose={this.handleSnackbarClose(1)}
                            ContentProps={{
                                'aria-describedby': 'message-id',
                            }}
                            message={<span id="message-id">{this.state.snackbarText}</span>}
                            action={[
                                <IconButton
                                  key="close"
                                  aria-label="Close"
                                  color="inherit"
                                  className={classes.close}
                                  onClick={this.handleSnackbarClose(1)}
                                >
                                  <CloseIcon />
                                </IconButton>,
                            ]}
                        />

                        <Snackbar
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            open={this.state.SnackbarOpen2}
                            autoHideDuration={6000}
                            onClose={this.handleSnackbarClose(2)}
                            style={{marginBottom: '100px'}}
                            ContentProps={{
                                'aria-describedby': 'message-id',
                            }}
                            message={<span id="message-id">{this.state.snackbarText}</span>}
                            action={[
                                <IconButton
                                  key="close"
                                  aria-label="Close"
                                  color="inherit"
                                  className={classes.close}
                                  onClick={this.handleSnackbarClose(2)}
                                >
                                  <CloseIcon />
                                </IconButton>,
                            ]}
                        />  
                    </div>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setKuesioner: Actions.setKuesioner,
        getKuesioner: Actions.getKuesioner,
        setKuesionerDirty: Actions.setKuesionerDirty,
        setRadioKuesioner: Actions.setRadioKuesioner,
        simpanKuesioner: Actions.simpanKuesioner,
        hitungRekapKemajuan: Actions.hitungRekapKemajuan,
        getSekolah: Actions.getSekolah,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        // // setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        setLoading: Actions.setLoading,
        getSemuaBadge: Actions.getSemuaBadge,
        toggleBadgeOpen: Actions.toggleBadgeOpen,
        setBadgePengguna: Actions.setBadgePengguna,
        setJudul: Actions.setJudul,
        setKepsekIsiKuesioner: Actions.setKepsekIsiKuesioner,
        getKemajuanTotal: Actions.getKemajuanTotal,
        setActiveStep: Actions.setActiveStep,
        setLoadingBesar: Actions.setLoadingBesar
    }, dispatch);
}

function mapStateToProps({ Instrumen, Sekolah, App, Pengguna, RaporMutu }) {

    // console.log(Instrumen.kuesioner);

    return {
        kuesioner: Instrumen.kuesioner,
        fetch_kuesioner: Instrumen.fetch_kuesioner,
        hasil_simpan: Instrumen.hasil_simpan,
        dirty: Instrumen.dirty,
        radioCheck: Instrumen.radioCheck,
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        loading: App.loading,
        semua_badge: Pengguna.semua_badge,
        toggle_badge: App.toggle_badge,
        badge_pengguna: Pengguna.badge_pengguna,
        window_dimension: App.window_dimension,
        kepsek_isi_kuesioner: App.kepsek_isi_kuesioner,
        kemajuan_total: Instrumen.kemajuan_total,
        active_step: RaporMutu.active_step
    }
}

// export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(RaporSPMSekolah)));
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(LembarInstrumenR)));





// WEBPACK FOOTER //
// ./src/main/content/Instrumen/LembarInstrumenR.js